import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

// Using styled API instead of makeStyles

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "error",
})(({ theme, error }) => ({
  "& .MuiFilledInput-root": {
    border: `1px solid ${error ? "#f15b60" : "#ced1d9"}`,
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "transparent",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      borderColor: error ? "#f15b60" : "#402ca8",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f5f5f7",
    },
    "& .MuiFilledInput-input": {
      color: theme.palette.primary.input,
      fontSize: 14,
      fontFamily: "Open Sans",
    },
  },
}));

export const TextInput = (props) => {
  return (
    <StyledTextField
      variant="filled"
      inputProps={{ autoComplete: "off" }} // Fixed camelCase
      InputProps={{
        disableUnderline: true,
        style: {
          backgroundColor: props.disabled ? "#f5f5f7" : "transparent",
          width: "100%",
          minHeight: "52px",
        },
      }}
      error={props.error}
      {...props}
    />
  );
};

TextInput.propTypes = {
  error: PropTypes.string,
  disabled: PropTypes.bool,
}